var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M17.73 9.908c.201-.698.304-1.418.304-2.146C18.034 3.482 14.533 0 10.23 0 5.928 0 2.427 3.482 2.427 7.762c0 .727.102 1.448.304 2.146-1.763 1.888-2.73 4.337-2.73 6.917C0 22.435 4.59 27 10.23 27c5.641 0 10.23-4.565 10.23-10.175 0-2.58-.967-5.029-2.73-6.917M15.87 8.572c-.016.113-.09.211-.194.259-.105.048-.227.04-.324-.022-1.532-.97-3.303-1.484-5.123-1.484-1.82 0-3.59.513-5.123 1.484-.056.034-.119.052-.182.052-.048 0-.097-.01-.142-.03-.104-.048-.177-.145-.193-.258-.045-.306-.065-.563-.065-.811 0-3.13 2.56-5.676 5.705-5.676 3.146 0 5.706 2.546 5.706 5.676 0 .247-.02.505-.065.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M7.619 16.69l1.613-.398c.191.27.512.509 1.063.509.591 0 .942-.29.942-.699 0-.458-.41-.707-.932-.707-.36 0-.732.11-1.073.33l-1.223-.35v-3.181H12.3v1.376H9.523v.838c.21-.12.571-.29 1.163-.29 1.404 0 2.155.918 2.155 2.005 0 1.126-.821 2.113-2.546 2.113-1.213 0-2.175-.478-2.676-1.545M8.915 21.48L8.654 21.744 8.654 22.414 8.119 22.414 8.119 19.063 8.654 19.063 8.654 21.109 9.611 20.118 10.268 20.118 9.269 21.123 10.304 22.414 9.647 22.414zM10.654 22.96l.26-.318c.144.161.387.264.692.264.41 0 .728-.201.728-.635v-.2h-.01c-.134.227-.453.406-.817.406-.642 0-1.145-.527-1.145-1.23 0-.691.49-1.219 1.145-1.219.36 0 .651.166.79.376h.01v-.314h.534v2.11c0 .697-.408 1.099-1.195 1.099-.444 0-.803-.125-.992-.34m1.666-1.707c0-.424-.287-.75-.7-.75-.414 0-.702.326-.702.75 0 .425.288.755.701.755.414 0 .701-.33.701-.755"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.0b4fba158162410748885d76700cae88.svg";
export { ForwardRef as ReactComponent };